(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-script"] && !Shopify.designMode) return;
  try {
    (() => {
    let cartDrawerStarted = false;

    const startCartDrawer = () => {
      if (cartDrawerStarted) {
        return;
      }

      const drawer = document.querySelector('[data-cart-drawer]');

      if (!drawer) {
        return;
      }

      cartDrawerStarted = true;

    const drawerItems = drawer.querySelector('[data-cart-drawer-items]');
    const drawerEmpty = drawer.querySelector('[data-cart-drawer-empty]');
    const drawerNotice = drawer.querySelector('[data-cart-drawer-notice]');
    const drawerCount = drawer.querySelector('[data-cart-drawer-count]');
    const drawerTotal = drawer.querySelector('[data-cart-drawer-total]');
    const drawerShipping = drawer.querySelector('[data-cart-drawer-shipping]');
    const drawerShippingMessage = drawer.querySelector('[data-cart-drawer-shipping-message]');
    const drawerShippingAmount = drawer.querySelector('[data-cart-drawer-shipping-amount]');
    const drawerShippingProgress = drawer.querySelector('[data-cart-drawer-shipping-progress]');
    const freeShippingThreshold = 5000;
    let lastCart = null;

    const moneyFormatter = (value, currency) => {
      try {
        return new Intl.NumberFormat('en-US', {
          currency: currency || 'USD',
          style: 'currency'
        }).format((Number(value) || 0) / 100);
      } catch (error) {
        return `$${((Number(value) || 0) / 100).toFixed(2)}`;
      }
    };

    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[character]));

    const analyticsItems = (items) => (Array.isArray(items) ? items : []).map((item) => ({
      item_id: String(item.variant_id || item.id || item.sku || ''),
      item_name: item.product_title || item.title || '',
      item_variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : undefined,
      price: Number(item.final_price || item.price || 0) / 100,
      quantity: Number(item.quantity || 1)
    }));

    const trackGa4Event = (eventName, params) => {
      const eventParams = params || {};

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventParams);
        return;
      }

      window.dataLayer = window.dataLayer || [];

      const ecommerceParams = {};

      if ('currency' in eventParams) {
        ecommerceParams.currency = eventParams.currency;
      }

      if ('value' in eventParams) {
        ecommerceParams.value = eventParams.value;
      }

      if ('items' in eventParams) {
        ecommerceParams.items = eventParams.items;
      }

      if (Object.keys(ecommerceParams).length > 0) {
        window.dataLayer.push({ ecommerce: null });
      }

      window.dataLayer.push({
        event: eventName,
        ...(Object.keys(ecommerceParams).length > 0 ? { ecommerce: ecommerceParams } : {}),
        ...eventParams
      });
    };

    const cartAnalyticsParams = (cart, context) => {
      const currentCart = cart || lastCart || {};

      return {
        currency: currentCart.currency || 'USD',
        items: analyticsItems(currentCart.items),
        value: Number(currentCart.total_price || 0) / 100,
        cart_context: context
      };
    };

    const trackAddToCart = (item, cart) => {
      const quantity = Number(item && item.quantity ? item.quantity : 1);
      const itemPrice = Number(item && (item.final_price || item.price) ? item.final_price || item.price : 0);

      trackGa4Event('add_to_cart', {
        currency: cart && cart.currency ? cart.currency : 'USD',
        value: (itemPrice * quantity) / 100,
        items: analyticsItems([item])
      });
    };

    const trackCartError = (message, form, status) => {
      const formData = form ? new FormData(form) : null;

      trackGa4Event('add_to_cart_error', {
        error_message: message || 'Unable to add item',
        error_status: status || '',
        page_path: window.location.pathname,
        variant_id: formData ? String(formData.get('id') || '') : ''
      });
    };

    const updateHeaderCartCount = (count) => {
      const cartLinks = document.querySelectorAll('.site-header__icons a[href="/cart"], .site-header__icons a[href*="/cart"]');

      cartLinks.forEach((link) => {
        let badge = link.querySelector('sup');

        if (!badge && count > 0) {
          badge = document.createElement('sup');
          link.append(badge);
        }

        if (badge) {
          badge.textContent = count;
          badge.hidden = count < 1;
        }
      });
    };

    const openDrawer = () => {
      const wasHidden = drawer.hidden;
      drawer.hidden = false;
      document.documentElement.classList.add('cart-drawer-open');

      if (wasHidden) {
        trackGa4Event('cart_drawer_open', cartAnalyticsParams(lastCart, 'cart_drawer'));
        trackGa4Event('view_cart', cartAnalyticsParams(lastCart, 'cart_drawer'));
      }
    };

    const closeDrawer = () => {
      drawer.hidden = true;
      document.documentElement.classList.remove('cart-drawer-open');
    };

    const renderDrawer = (cart, noticeText) => {
      const items = cart && Array.isArray(cart.items) ? cart.items : [];
      const currency = cart && cart.currency ? cart.currency : 'USD';
      lastCart = cart || lastCart;

      if (drawerNotice) {
        drawerNotice.textContent = noticeText || '';
        drawerNotice.hidden = !noticeText;
      }

      if (drawerEmpty) {
        drawerEmpty.hidden = items.length > 0;
      }

      if (drawerCount) {
        const itemCount = cart ? cart.item_count : 0;
        drawerCount.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'} in cart`;
      }

      if (drawerTotal) {
        drawerTotal.textContent = moneyFormatter(cart ? cart.total_price : 0, currency);
      }

      if (drawerShipping && drawerShippingMessage && drawerShippingAmount && drawerShippingProgress) {
        const totalPrice = cart ? Number(cart.total_price || 0) : 0;
        const remaining = Math.max(0, freeShippingThreshold - totalPrice);
        const progress = Math.min(100, Math.round((totalPrice / freeShippingThreshold) * 100));

        if (remaining > 0) {
          drawerShippingMessage.textContent = 'Add more to unlock free shipping';
          drawerShippingAmount.textContent = `${moneyFormatter(remaining, currency)} away`;
        } else {
          drawerShippingMessage.textContent = 'Free shipping unlocked';
          drawerShippingAmount.textContent = 'Qualified';
        }

        drawerShippingProgress.style.width = `${progress}%`;
      }

      if (!drawerItems) {
        return;
      }

      drawerItems.innerHTML = items.slice(0, 5).map((item) => {
        const image = item.image
          ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title)}" loading="lazy">`
          : '<span class="cart-drawer__placeholder" aria-hidden="true"></span>';
        const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const sku = item.sku ? `SKU: ${escapeHtml(item.sku)}` : '';

        return `
          <article class="cart-drawer__item" data-cart-line-key="${escapeHtml(item.key)}">
            <a class="cart-drawer__media" href="${escapeHtml(item.url || '#')}">${image}</a>
            <div class="cart-drawer__content">
              <a class="cart-drawer__title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title || item.title)}</a>
              <div class="cart-drawer__meta">
                ${variantTitle ? `<span>${escapeHtml(variantTitle)}</span>` : ''}
                ${sku ? `<span>${sku}</span>` : ''}
              </div>
              <div class="cart-drawer__line">
                <div class="cart-drawer__qty" aria-label="Cart quantity">
                  <button type="button" data-cart-drawer-minus aria-label="Decrease quantity">-</button>
                  <input type="number" min="0" value="${escapeHtml(item.quantity)}" data-cart-drawer-qty aria-label="Quantity for ${escapeHtml(item.product_title || item.title)}">
                  <button type="button" data-cart-drawer-plus aria-label="Increase quantity">+</button>
                </div>
                <strong>${moneyFormatter(item.final_line_price, currency)}</strong>
              </div>
              <button class="cart-drawer__remove" type="button" data-cart-drawer-remove>Remove</button>
            </div>
          </article>
        `;
      }).join('');

      if (items.length > 5) {
        drawerItems.innerHTML += `
          <a class="cart-drawer__notice" href="/cart">
            Showing latest 5. View ${items.length - 5} more on the cart page.
          </a>
        `;
      }
    };

    const fetchCart = async () => {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    };

    const changeLine = async (key, quantity) => {
      const response = await fetch('/cart/change.js', {
        body: JSON.stringify({
          id: key,
          quantity
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });

      if (!response.ok) {
        throw new Error('Unable to update cart');
      }

      return response.json();
    };

    const refreshDrawer = async (noticeText) => {
      const cart = await fetchCart();
      renderDrawer(cart, noticeText);
      updateHeaderCartCount(cart.item_count);
      return cart;
    };

    window.DealsClickCartDrawer = {
      close: closeDrawer,
      open(cart, noticeText) {
        renderDrawer(cart, noticeText || 'Product added to your cart.');
        updateHeaderCartCount(cart && cart.item_count ? cart.item_count : 0);
        openDrawer();
      },
      async refresh(noticeText) {
        const cart = await refreshDrawer(noticeText);
        openDrawer();
        return cart;
      }
    };

    document.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) {
        return;
      }

      const form = event.target.closest('form[action*="/cart/add"]');

      if (!form) {
        return;
      }

      const submitter = event.submitter;

      if (submitter && submitter.name === 'return_to') {
        return;
      }

      if (submitter && submitter.closest('.shopify-payment-button')) {
        return;
      }

      event.preventDefault();

      const button = submitter && submitter.matches('button, input[type="submit"]')
        ? submitter
        : form.querySelector('button[type="submit"], input[type="submit"]');
      const defaultText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          body: new FormData(form),
          headers: {
            Accept: 'application/json'
          },
          method: 'POST'
        });

        if (!addResponse.ok) {
          let errorMessage = 'Unable to add item';

          try {
            const errorBody = await addResponse.json();
            errorMessage = errorBody.description || errorBody.message || errorMessage;
          } catch (jsonError) {
            errorMessage = addResponse.statusText || errorMessage;
          }

          const addError = new Error(errorMessage);
          addError.status = addResponse.status;
          throw addError;
        }

        const item = await addResponse.json();
        const cart = await refreshDrawer('Product added to your cart.');
        trackAddToCart(item, cart);
        openDrawer();

        if (button) {
          button.textContent = 'Added';
          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = defaultText || 'Add to cart';
          }, 1200);
        }
      } catch (error) {
        trackCartError(error && error.message ? error.message : 'Unable to add item', form, error && error.status);

        if (button) {
          button.disabled = false;
          button.textContent = 'Try again';
          window.setTimeout(() => {
            button.textContent = defaultText || 'Add to cart';
          }, 1800);
        }
      }
    });

    document.addEventListener('click', (event) => {
      const checkoutTarget = event.target.closest('a[href="/checkout"], a[href*="/checkout"], button[name="checkout"], button[name="return_to"][value*="/checkout"]');

      if (!checkoutTarget) {
        return;
      }

      const context = checkoutTarget.closest('[data-cart-drawer]') ? 'cart_drawer' : 'cart_page';
      trackGa4Event('begin_checkout', cartAnalyticsParams(lastCart, context));
    });

    drawer.addEventListener('click', async (event) => {
      const closeButton = event.target.closest('[data-cart-drawer-close]');
      const line = event.target.closest('[data-cart-line-key]');

      if (closeButton) {
        closeDrawer();
        return;
      }

      if (!line) {
        return;
      }

      const key = line.dataset.cartLineKey;
      const quantityInput = line.querySelector('[data-cart-drawer-qty]');
      const currentQuantity = Math.max(0, Number(quantityInput ? quantityInput.value : 0) || 0);
      let nextQuantity = currentQuantity;

      if (event.target.closest('[data-cart-drawer-minus]')) {
        nextQuantity = Math.max(0, currentQuantity - 1);
      } else if (event.target.closest('[data-cart-drawer-plus]')) {
        nextQuantity = currentQuantity + 1;
      } else if (event.target.closest('[data-cart-drawer-remove]')) {
        nextQuantity = 0;
      } else {
        return;
      }

      line.style.opacity = '0.55';

      try {
        const cart = await changeLine(key, nextQuantity);
        renderDrawer(cart, nextQuantity === 0 ? 'Product removed from your cart.' : 'Cart updated.');
        updateHeaderCartCount(cart.item_count);
      } catch (error) {
        line.style.opacity = '';
      }
    });

    drawer.addEventListener('change', async (event) => {
      const quantityInput = event.target.closest('[data-cart-drawer-qty]');

      if (!quantityInput) {
        return;
      }

      const line = quantityInput.closest('[data-cart-line-key]');
      const key = line ? line.dataset.cartLineKey : '';
      const quantity = Math.max(0, Number(quantityInput.value || 0));

      if (!key) {
        return;
      }

      line.style.opacity = '0.55';

      try {
        const cart = await changeLine(key, quantity);
        renderDrawer(cart, quantity === 0 ? 'Product removed from your cart.' : 'Cart updated.');
        updateHeaderCartCount(cart.item_count);
      } catch (error) {
        line.style.opacity = '';
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hidden) {
        closeDrawer();
      }
    });

    window.addEventListener('dealsclick:cart-drawer-open', (event) => {
      if (event.detail && event.detail.cart) {
        renderDrawer(event.detail.cart, event.detail.notice || 'Product added to your cart.');
        updateHeaderCartCount(event.detail.cart.item_count || 0);
        openDrawer();
        event.detail.handled = true;
      }
    });

    refreshDrawer().catch(() => {});
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startCartDrawer, { once: true });
    } else {
      startCartDrawer();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["live-chat-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const startLiveChat = () => {
    const businessTimeZone = 'America/New_York';
    const activeDays = new Set(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);
    let chatReady = false;

    const markChatReady = () => {
      chatReady = true;
      document.documentElement.classList.add('dealsclick-chat-ready');
    };

    const deferChatReady = () => {
      const runWhenIdle = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(markChatReady, { timeout: 2200 });
        } else {
          window.setTimeout(markChatReady, 1400);
        }
      };

      if (document.readyState === 'complete') {
        runWhenIdle();
      } else {
        window.addEventListener('load', runWhenIdle, { once: true });
      }
    };

    const getEasternParts = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: businessTimeZone,
        weekday: 'short',
        hour: 'numeric',
        hour12: false
      }).formatToParts(new Date());

      const values = {};
      parts.forEach((part) => {
        values[part.type] = part.value;
      });

      return values;
    };

    const isBusinessHours = () => {
      const parts = getEasternParts();
      const hour = Number(parts.hour === '24' ? '0' : parts.hour);

      return activeDays.has(parts.weekday) && hour >= 9 && hour < 17;
    };

    const updateLiveChatStatus = () => {
      const online = isBusinessHours();
      const statusNodes = document.querySelectorAll('[data-live-chat-status], [data-live-chat-presence]');

      statusNodes.forEach((node) => {
        const activeText = node.getAttribute('data-active-text') || 'Online now';
        const inactiveText = node.getAttribute('data-inactive-text') || 'Mon-Fri, 9am-5pm ET';

        node.textContent = online ? activeText : inactiveText;
        node.classList.toggle('is-online', online);
        node.classList.toggle('is-offline', !online);
      });

      document.documentElement.toggleAttribute('data-live-chat-online', online);
    };

    const clickElement = (element) => {
      if (!element) {
        return false;
      }

      if (typeof element.click === 'function') {
        element.click();
      } else {
        element.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, composed: true, view: window }));
      }

      return true;
    };

    const getShopifyInbox = () =>
      document.querySelector('#ShopifyChat, #shopify-chat inbox-online-store-chat, inbox-online-store-chat');

    const getShopifyInboxToggle = (shopifyChat) =>
      shopifyChat && shopifyChat.shadowRoot && shopifyChat.shadowRoot.querySelector(
        'button[data-spec="toggle-button"], button.chat-toggle, button[aria-expanded]'
      );

    const isShopifyInboxOpen = (shopifyChat) => {
      if (!shopifyChat) {
        return false;
      }

      const shadowToggle = getShopifyInboxToggle(shopifyChat);

      if (shadowToggle && shadowToggle.getAttribute('aria-expanded') === 'true') {
        return true;
      }

      return shopifyChat.getAttribute('is-open') === 'true';
    };

    const syncChatTriggerState = (open) => {
      document.querySelectorAll('[data-open-live-chat]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        trigger.classList.toggle('is-chat-open', open);
      });
    };

    const setShopifyInboxOpen = (open) => {
      const shopifyChat = getShopifyInbox();

      if (!shopifyChat) {
        return false;
      }

      shopifyChat.setAttribute('is-open', open ? 'true' : 'false');

      try {
        shopifyChat.isOpen = open;
        shopifyChat.open = open;
      } catch (error) {
        // Shopify Inbox is a web component; some builds expose read-only properties.
      }

      const shadowToggle = getShopifyInboxToggle(shopifyChat);
      const expanded = shadowToggle && shadowToggle.getAttribute('aria-expanded') === 'true';

      if (shadowToggle && expanded !== open) {
        clickElement(shadowToggle);
      }

      syncChatTriggerState(open);
      return true;
    };

    const toggleShopifyInbox = () => {
      const shopifyChat = getShopifyInbox();

      if (!shopifyChat) {
        return false;
      }

      return setShopifyInboxOpen(!isShopifyInboxOpen(shopifyChat));
    };

    const openShopifyInbox = () => setShopifyInboxOpen(true);

    const clickChatLauncher = () => {
      if (openShopifyInbox()) {
        return true;
      }

      const selectors = [
        '.chat-app button[data-spec="toggle-button"]',
        'button[data-spec="toggle-button"].chat-toggle',
        'button[data-spec="toggle-button"][aria-expanded]',
        'button.chat-toggle'
      ];
      const launcher = selectors
        .flatMap((selector) => Array.from(document.querySelectorAll(selector)))
        .find((button) => {
          if (button.closest('[data-open-live-chat]')) {
            return false;
          }

          const rect = button.getBoundingClientRect();
          return rect.width > 0 && rect.height > 0;
        });

      if (launcher) {
        clickElement(launcher);
        return true;
      }

      return false;
    };

    const openLiveChat = async () => {
      if (!chatReady) {
        markChatReady();
        await new Promise((resolve) => {
          window.setTimeout(resolve, 300);
        });
      }

      if (clickChatLauncher()) {
        return;
      }

      if (window.ShopifyInbox && typeof window.ShopifyInbox.open === 'function') {
        window.ShopifyInbox.open();
        return;
      }

      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
        return;
      }

      if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
        window.Tawk_API.maximize();
        return;
      }

      if (typeof window.Intercom === 'function') {
        window.Intercom('show');
        return;
      }

      if (window.$crisp && Array.isArray(window.$crisp)) {
        window.$crisp.push(['do', 'chat:open']);
        return;
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, 500);
      });

      if (clickChatLauncher()) {
        return;
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, 900);
      });

      if (clickChatLauncher()) {
        return;
      }

      const launcher = document.querySelector(
        '[aria-label*="chat" i], [aria-label*="message" i], [class*="chat" i] button, button[class*="chat" i], iframe[title*="chat" i]'
      );

      if (launcher && launcher.tagName !== 'IFRAME' && !launcher.closest('[data-open-live-chat]')) {
        clickElement(launcher);
        return;
      }

      window.location.href = '/pages/contact';
    };

    const toggleLiveChat = async () => {
      if (toggleShopifyInbox()) {
        return;
      }

      await openLiveChat();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-open-live-chat]');

      if (!trigger) {
        return;
      }

      event.preventDefault();
      toggleLiveChat();
    });

    updateLiveChatStatus();
    window.setInterval(updateLiveChatStatus, 60000);
    deferChatReady();
    };

    const scheduleLiveChat = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(startLiveChat, { timeout: 1800 });
      } else {
        window.setTimeout(startLiveChat, 900);
      }
    };

    if (document.readyState === 'complete') {
      scheduleLiveChat();
    } else {
      window.addEventListener('load', scheduleLiveChat, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quote-list-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const startQuoteList = () => {
    const itemKey = 'dealsclick:quote-items';
    const zipKey = 'dealsclick:quote-zip';
    const noticeKey = 'dealsclick:quote-notice';

    const readItems = () => {
      try {
        const parsed = JSON.parse(localStorage.getItem(itemKey) || '[]');
        return Array.isArray(parsed) ? parsed.filter((item) => item && item.id) : [];
      } catch (error) {
        return [];
      }
    };

    const writeItems = (items) => {
      localStorage.setItem(itemKey, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('dealsclick:quote-updated'));
    };

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const quoteCount = (items = readItems()) => items.reduce((total, item) => total + Number(item.quantity || 1), 0);

    const createReferenceId = () => {
      const now = new Date();
      const pad = (value) => String(value).padStart(2, '0');
      return `QDC-${pad(now.getMonth() + 1)}${pad(now.getDate())}${String(now.getFullYear()).slice(-2)}-${pad(now.getHours())}${pad(now.getMinutes())}`;
    };

    const setQuoteReference = () => {
      const referenceInput = document.querySelector('[data-quote-reference-input]');
      const referenceOutputs = document.querySelectorAll('[data-quote-reference]');

      if (!referenceInput && !referenceOutputs.length) {
        return '';
      }

      let reference = sessionStorage.getItem('dealsclick:quote-reference') || '';

      if (!reference) {
        reference = createReferenceId();
        sessionStorage.setItem('dealsclick:quote-reference', reference);
      }

      if (referenceInput) {
        referenceInput.value = reference;
      }

      referenceOutputs.forEach((referenceOutput) => {
        referenceOutput.textContent = reference;
      });

      return reference;
    };

    const updateCounts = () => {
      const count = quoteCount();
      document.querySelectorAll('[data-quote-count]').forEach((element) => {
        element.textContent = count;
        element.hidden = count === 0;
      });
    };

    const drawer = document.querySelector('[data-quote-drawer]');
    const drawerItems = document.querySelector('[data-quote-drawer-items]');
    const drawerEmpty = document.querySelector('[data-quote-drawer-empty]');
    const drawerSummary = document.querySelector('[data-quote-drawer-summary]');

    const openQuoteDrawer = () => {
      if (!drawer) {
        return;
      }

      drawer.hidden = false;
      document.documentElement.classList.add('quote-drawer-open');
    };

    const closeQuoteDrawer = () => {
      if (!drawer) {
        return;
      }

      drawer.hidden = true;
      document.documentElement.classList.remove('quote-drawer-open');
    };

    const renderQuoteDrawer = () => {
      if (!drawerItems || !drawerEmpty || !drawerSummary) {
        return;
      }

      const items = readItems();
      const count = quoteCount(items);
      const previewItems = items.slice(0, 5);
      drawerSummary.textContent = count === 1 ? '1 item in quote' : `${count} items in quote`;
      drawerEmpty.hidden = items.length > 0;

      drawerItems.innerHTML = previewItems
        .map((item) => {
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
            : '<span class="quote-drawer__placeholder" aria-hidden="true"></span>';
          const meta = [
            item.sku ? `SKU: ${escapeHtml(item.sku)}` : '',
            item.storeSku ? `Store SKU: ${escapeHtml(item.storeSku)}` : '',
            item.variantTitle && item.variantTitle !== 'Default Title' ? escapeHtml(item.variantTitle) : ''
          ].filter(Boolean);

          return `
            <article class="quote-drawer__item" data-quote-id="${escapeHtml(item.id)}">
              <a class="quote-drawer__media" href="${escapeHtml(item.url || '#')}">${image}</a>
              <div class="quote-drawer__content">
                ${item.brand ? `<p class="quote-drawer__brand">${escapeHtml(item.brand)}</p>` : ''}
                <a class="quote-drawer__title" href="${escapeHtml(item.url || '#')}">${escapeHtml(item.title)}</a>
                ${meta.length ? `<div class="quote-drawer__meta">${meta.map((line) => `<span>${line}</span>`).join('')}</div>` : ''}
                <div class="quote-drawer__controls">
                  <label>
                    Qty
                    <input type="number" min="1" value="${escapeHtml(item.quantity || 1)}" data-quote-qty>
                  </label>
                  <button type="button" data-quote-remove>Remove</button>
                </div>
              </div>
            </article>
          `;
        })
        .join('');

      if (items.length > previewItems.length) {
        drawerItems.innerHTML += `
          <a class="quote-drawer__more" href="/pages/request-quote">
            Showing latest ${previewItems.length}. View ${items.length - previewItems.length} more on the full quote list.
          </a>
        `;
      }
    };

    const showQuoteFeedback = (item) => {
      document.querySelectorAll('[data-quote-feedback]').forEach((element) => {
        element.innerHTML = `${escapeHtml(item.title || 'Item')} added to your quote list. <a href="/pages/request-quote">View quote list</a>`;
        element.hidden = false;
      });
    };

    const addItem = (button) => {
      const card = button.closest('[data-quote-card]');
      const quantityInput = card ? card.querySelector('[data-quote-card-qty]') : document.querySelector('.product-page__quantity input');
      const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
      const item = {
        id: button.dataset.productVariantId || button.dataset.productSku || button.dataset.productUrl,
        title: button.dataset.productTitle || '',
        url: button.dataset.productUrl || '',
        image: button.dataset.productImage || '',
        brand: button.dataset.productBrand || '',
        sku: button.dataset.productSku || '',
        storeSku: button.dataset.productStoreSku || '',
        upc: button.dataset.productUpc || '',
        variantId: button.dataset.productVariantId || '',
        variantTitle: button.dataset.productVariantTitle || '',
        quantity
      };

      const items = readItems();
      const index = items.findIndex((entry) => entry.id === item.id);

      if (index >= 0) {
        items[index].quantity = Number(items[index].quantity || 1) + quantity;
      } else {
        items.unshift(item);
      }

      writeItems(items);
      showQuoteFeedback(item);
      renderQuoteDrawer();
      if (button.dataset.quoteRedirect !== 'true') {
        window.setTimeout(openQuoteDrawer, 0);
      }
      button.classList.add('is-added');
      button.textContent = 'Added to Quote';
      window.setTimeout(() => {
        button.classList.remove('is-added');
        button.textContent = button.dataset.defaultLabel || 'Add to Quote';
      }, 1500);

      if (button.dataset.quoteRedirect === 'true') {
        localStorage.setItem(noticeKey, 'Item added to your quote list.');
        window.location.href = button.dataset.quotePage || '/pages/request-quote';
      }
    };

    const buildSummary = (items, reference = '') => {
      const totalQuantity = quoteCount(items);
      const header = [
        'DealsClick multi-SKU quote request',
        reference ? `Reference ID: ${reference}` : '',
        `Generated: ${new Date().toLocaleString('en-US')}`,
        `Quote page: ${window.location.href}`,
        `Unique SKUs: ${items.length}`,
        `Total quantity: ${totalQuantity}`,
        ''
      ].filter(Boolean);

      const rows = items.map((item, index) => [
        `Line ${index + 1}`,
        `SKU: ${item.sku || '-'}`,
        `Store SKU: ${item.storeSku || '-'}`,
        `UPC: ${item.upc || '-'}`,
        `Brand: ${item.brand || '-'}`,
        `Product: ${item.title || '-'}`,
        `Option: ${item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '-'}`,
        `Quantity: ${item.quantity || 1}`,
        item.url ? `Product URL: ${item.url}` : ''
      ].filter(Boolean).join('\n'));

      return header.concat(rows).join('\n\n');
    };

    const openCartDrawerFromQuote = (cart) => {
      const cartDrawerEvent = new CustomEvent('dealsclick:cart-drawer-open', {
        detail: {
          cart,
          handled: false,
          notice: 'Quote item added to your cart.'
        }
      });
      window.dispatchEvent(cartDrawerEvent);
    };

    const addQuoteItemToCart = async (item, quantity) => {
      if (!item || !item.variantId) {
        throw new Error('Missing variant ID');
      }

      const addResponse = await fetch('/cart/add.js', {
        body: JSON.stringify({
          id: item.variantId,
          quantity
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });

      if (!addResponse.ok) {
        throw new Error('Unable to add quote item to cart');
      }

      await addResponse.json();

      const cartResponse = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Unable to load cart');
      }

      return cartResponse.json();
    };

    const printQuoteSheet = () => {
      const printSheet = document.querySelector('[data-quote-print]');

      if (!printSheet) {
        window.print();
        return;
      }

      const printWindow = window.open('', 'DealsClickQuotePrint', 'width=900,height=1100');

      if (!printWindow) {
        window.print();
        return;
      }

      printWindow.document.write(`
        <!doctype html>
        <html>
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1">
            <title>DealsClick Quote</title>
            <style>
              @page {
                margin: 0.4in;
                size: letter;
              }

              * {
                box-sizing: border-box;
              }

              body {
                background: #ffffff;
                color: #111827;
                font-family: Arial, Helvetica, sans-serif;
                font-size: 10pt;
                line-height: 1.35;
                margin: 0;
              }

              .quote-list__print {
                display: block;
              }

              .quote-list__print-header {
                align-items: start;
                border-bottom: 2px solid #111827;
                display: flex;
                gap: 0.3in;
                justify-content: space-between;
                padding-bottom: 0.16in;
              }

              .quote-list__print-header > div:first-child {
                display: grid;
                gap: 0.04in;
              }

              .quote-list__print-header strong {
                color: #111827;
                display: block;
                font-size: 26pt;
                font-weight: 900;
                letter-spacing: -0.01em;
                line-height: 1;
              }

              .quote-list__print-header span {
                color: #374151;
                display: block;
                font-size: 9pt;
                line-height: 1.35;
              }

              .quote-list__print-header > div:last-child {
                text-align: right;
              }

              .quote-list__print-meta {
                border: 1px solid #d1d5db;
                display: grid;
                grid-template-columns: 1fr 1fr;
                margin: 0.18in 0;
              }

              .quote-list__print-meta div {
                display: grid;
                gap: 0.02in;
                padding: 0.08in 0.1in;
              }

              .quote-list__print-meta div + div {
                border-left: 1px solid #d1d5db;
              }

              .quote-list__print-meta span {
                color: #6b7280;
                font-size: 7.5pt;
                font-weight: 800;
                letter-spacing: 0.04em;
                text-transform: uppercase;
              }

              .quote-list__print-meta strong {
                color: #111827;
                font-size: 10pt;
                font-weight: 900;
              }

              .quote-list__print-table {
                border-collapse: collapse;
                color: #111827;
                font-size: 8.5pt;
                table-layout: fixed;
                width: 100%;
              }

              .quote-list__print-table th {
                background: #111827;
                border: 1px solid #111827;
                color: #ffffff;
                font-size: 7.5pt;
                font-weight: 900;
                letter-spacing: 0.04em;
                padding: 0.07in 0.06in;
                text-align: left;
                text-transform: uppercase;
              }

              .quote-list__print-table td {
                border: 1px solid #d1d5db;
                color: #111827;
                padding: 0.07in 0.06in;
                vertical-align: top;
                word-break: break-word;
              }

              .quote-list__print-table td:first-child,
              .quote-list__print-table td:last-child {
                text-align: center;
              }

              .quote-list__print-table th:nth-child(1),
              .quote-list__print-table td:nth-child(1) {
                width: 0.38in;
              }

              .quote-list__print-table th:nth-child(2),
              .quote-list__print-table td:nth-child(2),
              .quote-list__print-table th:nth-child(3),
              .quote-list__print-table td:nth-child(3) {
                width: 0.95in;
              }

              .quote-list__print-table th:nth-child(4),
              .quote-list__print-table td:nth-child(4),
              .quote-list__print-table th:nth-child(6),
              .quote-list__print-table td:nth-child(6) {
                width: 0.85in;
              }

              .quote-list__print-table th:nth-child(7),
              .quote-list__print-table td:nth-child(7) {
                width: 0.42in;
              }

              .quote-list__print-table tbody tr {
                break-inside: avoid;
                page-break-inside: avoid;
              }

              .quote-list__print-note {
                border-top: 1px solid #d1d5db;
                color: #4b5563;
                font-size: 8pt;
                line-height: 1.35;
                margin: 0.18in 0 0;
                padding-top: 0.1in;
              }

              .quote-list__print-note::after {
                color: #111827;
                content: " | DealsClick quote request";
                font-weight: 800;
              }
            </style>
          </head>
          <body>
            ${printSheet.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      window.setTimeout(() => {
        printWindow.print();
      }, 250);
    };

    const renderQuotePage = () => {
      const quoteList = document.querySelector('[data-quote-list]');
      const emptyState = document.querySelector('[data-quote-empty]');
      const formWrap = document.querySelector('[data-quote-form-wrap]');
      const printList = document.querySelector('[data-quote-print-list]');
      const printDate = document.querySelector('[data-quote-print-date]');
      const textarea = document.querySelector('[data-quote-items-input]');
      const itemCountInput = document.querySelector('[data-quote-item-count-input]');
      const totalQuantityInput = document.querySelector('[data-quote-total-quantity-input]');
      const pageUrlInput = document.querySelector('[data-quote-page-url-input]');
      const generatedAtInput = document.querySelector('[data-quote-generated-at-input]');
      const zipInput = document.querySelector('[data-quote-zip-input]');
      const notice = document.querySelector('[data-quote-notice]');

      if (!quoteList) {
        return;
      }

      const items = readItems();
      const reference = setQuoteReference();
      const generatedAt = new Date().toLocaleString('en-US');
      const savedZip = localStorage.getItem(zipKey) || '';
      const savedNotice = localStorage.getItem(noticeKey) || '';

      if (zipInput && savedZip && !zipInput.value) {
        zipInput.value = savedZip;
      }

      if (notice && savedNotice) {
        notice.textContent = savedNotice;
        notice.hidden = false;
        localStorage.removeItem(noticeKey);
      }

      if (emptyState) {
        emptyState.hidden = items.length > 0;
      }

      if (formWrap) {
        formWrap.hidden = items.length === 0;
      }

      if (textarea) {
        textarea.value = buildSummary(items, reference);
      }

      if (itemCountInput) {
        itemCountInput.value = String(items.length);
      }

      if (totalQuantityInput) {
        totalQuantityInput.value = String(quoteCount(items));
      }

      if (pageUrlInput) {
        pageUrlInput.value = window.location.href;
      }

      if (generatedAtInput) {
        generatedAtInput.value = generatedAt;
      }

      if (printDate) {
        printDate.textContent = new Date().toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });
      }

      if (printList) {
        printList.innerHTML = items
          .map((item, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${escapeHtml(item.sku || '-')}</td>
              <td>${escapeHtml(item.storeSku || '-')}</td>
              <td>${escapeHtml(item.brand || '-')}</td>
              <td>${escapeHtml(item.title || '-')}</td>
              <td>${escapeHtml(item.variantTitle && item.variantTitle !== 'Default Title' ? item.variantTitle : '-')}</td>
              <td>${escapeHtml(item.quantity || 1)}</td>
            </tr>
          `)
          .join('');
      }

      quoteList.innerHTML = items
        .map((item) => {
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
            : '<span aria-hidden="true"></span>';

          return `
            <article class="quote-list__item" data-quote-id="${escapeHtml(item.id)}">
              <a class="quote-list__media" href="${escapeHtml(item.url || '#')}">${image}</a>
              <div class="quote-list__content">
                ${item.brand ? `<p>${escapeHtml(item.brand)}</p>` : ''}
                <h2><a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.title)}</a></h2>
                <dl>
                  ${item.sku ? `<div><dt>SKU</dt><dd>${escapeHtml(item.sku)}</dd></div>` : ''}
                  ${item.storeSku ? `<div><dt>Store SKU</dt><dd>${escapeHtml(item.storeSku)}</dd></div>` : ''}
                  ${item.upc ? `<div><dt>UPC</dt><dd>${escapeHtml(item.upc)}</dd></div>` : ''}
                </dl>
                <div class="quote-list__controls">
                  <label>
                    <span>Qty</span>
                    <input type="number" min="1" value="${escapeHtml(item.quantity || 1)}" data-quote-qty>
                  </label>
                  <button class="quote-list__cart-button" type="button" data-quote-cart-add ${item.variantId ? '' : 'disabled'}>
                    Add to cart
                  </button>
                  <button type="button" data-quote-remove>Remove</button>
                </div>
              </div>
            </article>
          `;
        })
        .join('');
    };

    document.addEventListener('click', (event) => {
      const addButton = event.target.closest('[data-quote-add]');

      if (addButton) {
        addButton.dataset.defaultLabel = addButton.dataset.defaultLabel || addButton.textContent.trim();
        addItem(addButton);
        return;
      }

      const printButton = event.target.closest('[data-print-quote]');

      if (printButton) {
        setQuoteReference();
        renderQuotePage();
        printQuoteSheet();
        return;
      }

      const cartButton = event.target.closest('[data-quote-cart-add]');

      if (cartButton) {
        const itemElement = cartButton.closest('[data-quote-id]');
        const itemId = itemElement ? itemElement.dataset.quoteId : '';
        const quantityInput = itemElement ? itemElement.querySelector('[data-quote-qty]') : null;
        const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
        const item = readItems().find((entry) => entry.id === itemId);
        const defaultText = cartButton.textContent;

        cartButton.disabled = true;
        cartButton.textContent = 'Adding...';

        addQuoteItemToCart(item, quantity)
          .then((cart) => {
            openCartDrawerFromQuote(cart);
            cartButton.textContent = 'Added';
            window.setTimeout(() => {
              cartButton.disabled = false;
              cartButton.textContent = defaultText;
            }, 1200);
          })
          .catch(() => {
            cartButton.textContent = 'Try again';
            window.setTimeout(() => {
              cartButton.disabled = false;
              cartButton.textContent = defaultText;
            }, 1600);
          });
        return;
      }

      const removeButton = event.target.closest('[data-quote-remove]');

      if (removeButton) {
        const itemElement = removeButton.closest('[data-quote-id]');
        const itemId = itemElement ? itemElement.dataset.quoteId : '';
        writeItems(readItems().filter((item) => item.id !== itemId));
        renderQuotePage();
        renderQuoteDrawer();
      }
    });

    document.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('[data-quote-qty]');

      if (!quantityInput) {
        return;
      }

      const itemElement = quantityInput.closest('[data-quote-id]');
      const itemId = itemElement ? itemElement.dataset.quoteId : '';
      const quantity = Math.max(1, Number(quantityInput.value || 1));
      const items = readItems().map((item) => {
        if (item.id === itemId) {
          item.quantity = quantity;
        }
        return item;
      });

      writeItems(items);
      renderQuotePage();
      renderQuoteDrawer();
    });

    document.addEventListener('input', (event) => {
      const zipInput = event.target.closest('[data-quote-zip-input]');

      if (zipInput) {
        localStorage.setItem(zipKey, zipInput.value);
      }
    });

    document.addEventListener('submit', (event) => {
      if (event.target.matches('.quote-list__form')) {
        setQuoteReference();
        localStorage.removeItem(itemKey);
        localStorage.removeItem(zipKey);
        sessionStorage.removeItem('dealsclick:quote-reference');
      }
    });

    window.addEventListener('dealsclick:quote-updated', () => {
      updateCounts();
      renderQuotePage();
      renderQuoteDrawer();
    });

    document.querySelectorAll('[data-quote-drawer-close]').forEach((button) => {
      button.addEventListener('click', closeQuoteDrawer);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer && !drawer.hidden) {
        closeQuoteDrawer();
      }
    });

    updateCounts();
    setQuoteReference();
    renderQuotePage();
    renderQuoteDrawer();
    };

    const scheduleQuoteList = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(startQuoteList, { timeout: 1800 });
      } else {
        window.setTimeout(startQuoteList, 900);
      }
    };

    if (document.readyState === 'complete') {
      scheduleQuoteList();
    } else {
      window.addEventListener('load', scheduleQuoteList, { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["review-trust-enhancer"] && !Shopify.designMode) return;
  try {
    (() => {
    const reviewSelector = '.reputon-ebay-reviews-widget, .reputon-reviews-holder, [id*="ebay_reviews_carousel_widget" i]';
    const targetId = 'trusted-reviews';

    const getReviewSection = () => {
      const widget = document.querySelector(reviewSelector);
      if (!widget) return null;

      const section = widget.closest('.shopify-section') || widget.parentElement;
      if (!section) return null;

      return { section, widget };
    };

    const enhanceReviews = () => {
      const found = getReviewSection();
      if (!found) return false;

      const { section } = found;
      if (section.dataset.dealsclickReviewEnhanced === 'true') return true;

      section.id = targetId;
      section.classList.add('dealsclick-review-proof');
      section.dataset.dealsclickReviewEnhanced = 'true';

      const inner = document.createElement('div');
      inner.className = 'dealsclick-review-proof__inner';

      while (section.firstChild) {
        inner.appendChild(section.firstChild);
      }

      const header = document.createElement('div');
      header.className = 'dealsclick-review-proof__header';
      header.innerHTML = `
        <div>
          <p class="dealsclick-review-proof__kicker">Marketplace trust</p>
          <h2 class="dealsclick-review-proof__title">Trusted by marketplace buyers</h2>
          <p class="dealsclick-review-proof__text">Trusted reviews from our eBay shop to help shoppers buy with confidence.</p>
        </div>
        <div class="dealsclick-review-proof__stats" aria-label="Marketplace review highlights">
          <div class="dealsclick-review-proof__stat"><strong>98.8%</strong><span>positive feedback</span></div>
          <div class="dealsclick-review-proof__stat"><strong>18K+</strong><span>buyer reviews</span></div>
          <div class="dealsclick-review-proof__stat"><strong>eBay</strong><span>shop reviews</span></div>
        </div>
      `;

      const source = document.createElement('p');
      source.className = 'dealsclick-review-proof__source';
      source.textContent = 'Trusted reviews from our DealsClick eBay shop.';

      inner.insertBefore(header, inner.firstChild);
      inner.appendChild(source);
      section.appendChild(inner);

      return true;
    };

    const scrollToReviews = (event) => {
      const trigger = event.target.closest('[data-review-scroll-link], a[href$="#trusted-reviews"]');
      if (!trigger) return;

      const enhanced = enhanceReviews();
      const target = document.getElementById(targetId);
      if (!enhanced || !target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.pushState) {
        history.pushState(null, '', '#trusted-reviews');
      }
    };

    const start = () => {
      if (enhanceReviews()) {
        if (window.location.hash === `#${targetId}`) {
          document.getElementById(targetId)?.scrollIntoView({ block: 'start' });
        }
        return;
      }

      const observer = new MutationObserver(() => {
        if (enhanceReviews()) {
          observer.disconnect();
          if (window.location.hash === `#${targetId}`) {
            document.getElementById(targetId)?.scrollIntoView({ block: 'start' });
          }
        }
      });

      observer.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 15000);
    };

    const scheduleStart = () => {
      if (window.location.hash === `#${targetId}`) {
        start();
        return;
      }

      const runWhenIdle = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(start, { timeout: 4000 });
          return;
        }

        window.setTimeout(start, 1800);
      };

      if (document.readyState === 'complete') {
        runWhenIdle();
      } else {
        window.addEventListener('load', runWhenIdle, { once: true });
      }
    };

    document.addEventListener('click', scrollToReviews);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleStart, { once: true });
    } else {
      scheduleStart();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
